import type {
  QueryDocumentSnapshot,
  SnapshotOptions,
} from "firebase/firestore";
import type { ICase } from "~~/types/case";
import type { EService } from "~~/types/information";
import compactObject from "~/utils/compact-object";

export const caseConverter = {
  toFirestore(data: any): ICase {
    return compactObject({
      id: data.id,
      regNum: data.regNum,
      clientRegNum: data.clientRegNum,
      vinNumber: data.vinNumber,
      callerName: data.callerName,
      status: data.status,
      faultCode: data.faultCode,
      policyType: data.policyType,
      images: data.images,
      statusTimestamp: data.statusTimestamp,
      userData: data.userData,
      choosedService: data.choosedService,
      location: data.location,
      payment: data.payment,
      internalRemarks: data.internalRemarks,
      externalRemarks: data.externalRemarks,
      createdFrom: data.createdFrom,
      liveTracking: data.liveTracking,
      etaReminderAcknowledgedBy: data.etaReminderAcknowledgedBy,
      clientEmail: data.clientEmail,
      clientEmailCompletion: data.clientEmailCompletion,
    }) as ICase;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ): ICase {
    const data = snapshot.data(options);

    let choosedService: EService[] = [];

    if (Array.isArray(data.choosedService)) {
      choosedService = data.choosedService;
    } else if (typeof data.choosedService === "object") {
      choosedService = Object.keys(data.choosedService);
    } else {
      choosedService = data.choosedService;
    }

    return {
      id: snapshot.id,
      regNum: data.regNum,
      clientRegNum: data.clientRegNum,
      vinNumber: data.vinNumber ?? null,
      callerName: data.callerName,
      status: data.status,
      faultCode: data.faultCode,
      policyType: data.policyType,
      images: data.images,
      statusTimestamp: data.statusTimestamp,
      userData: data.userData,
      choosedService,
      location: {
        from: {
          coord: {
            latitude: data.location?.from?.coord?.latitude,
            longitude: data.location?.from?.coord?.longitude,
          },
          address: data.location?.from?.address,
          generatedAddress: data.location?.from?.generatedAddress,
        },
        to: {
          coord: {
            latitude: data.location.to.coord.latitude,
            longitude: data.location.to.coord.longitude,
          },
          address: data.location.to.address,
          generatedAddress: data.location.to.generatedAddress,
          workshop: data.location.to.workshop ?? null,
        },
        state: data.location.state,
        city: data.location.city,
        distance: data.location.distance,
      },
      payment: data.payment,
      internalRemarks: data.internalRemarks,
      externalRemarks: data.externalRemarks,
      closeReason: data.closeReason,
      createdFrom: data.createdFrom,
      liveTracking: data.liveTracking,
      etaReminderAcknowledgedBy: data.etaReminderAcknowledgedBy,
      clientEmail: data.clientEmail,
      clientEmailCompletion: data.clientEmailCompletion,
    };
  },
};
